const modules = {};

// 动态导入当前文件夹中的所有 .js 文件，排除 index.js
const requireModule = require.context(".", false, /\.js$/);

requireModule.keys().forEach((fileName) => {
  if (fileName === "./index.js") return; // 排除自身

  // 获取模块的内容
  const moduleName = fileName.replace(/(\.\/|\.js)/g, "");
  modules[moduleName] = requireModule(fileName).default;
});
export default modules;
